// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span data-screen-size-value=\"SMALL\"></span>\n<span data-screen-size-value=\"MEDIUM\"></span>\n<span data-screen-size-value=\"MEDIUM_LANDSCAPE\"></span>\n<span data-screen-size-value=\"LARGE\"></span>\n<span data-screen-size-value=\"EXTRA_LARGE\"></span>\n";
},"useData":true});
